import { Injectable } from '@angular/core';

import { DprAttachmentsGridData, Sync } from '@shared/models/grid';

@Injectable()
export class DprAppendixGridService {
  mapToGridSync(
    changes: Sync<DprAttachmentsGridData>
  ): Sync<DprAttachmentsGridData> {
    const result: Sync<DprAttachmentsGridData> = {
      addedList: [],
      updatedList: [],
      deletedIds: changes?.deletedIds ?? [],
    };

    result.addedList.push(...(changes?.addedList ?? [])); // needed for offline
    result.addedList.push(
      ...(changes?.updatedList?.filter((x) => isNaN(+x.id)) ?? [])
    );

    result.updatedList = changes?.updatedList?.filter((x) => !isNaN(+x.id));

    return result;
  }
}
